import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { Box, useTheme } from "@mui/material";
import cx from 'classnames';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Text from "../../../../theme/text/Text";
import { tokens } from "../../../../../theme";
import { countriesFromLocale } from '../../../../../utils/countries';
import { categoryAllBehaviors, reportFilterDataSource } from '../../chartFilterEnums';
import { useEffect, useState } from 'react';
import { DropdownBaseV2 } from '../../../../theme/dropdowns/Dropdown';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarIcon from '@mui/icons-material/Star';
import CloseIcon from '@mui/icons-material/Close';
import { useReportHubFilters } from '../../ReportHubFilterContext';
import MCountrySelector from '../../../Modals/MCountrySelector';

export const CategoryCountryDropdown = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const filtersRegistry = useReportHubFilters();

    const [logoOpen,setLogoOpen] = useState(false);

    const filter = filtersRegistry.filters[props.fKey];
    const resolvedFilter = typeof filter === "function" ? filter() : filter;

    const language = useSelector((state) => state.settings.language);
    const allCountries = countriesFromLocale(language);

    // With the flag set no values are stored, so the modal reopens from the full list and the chip
    // counts that instead — the chart still only draws the countries that were actually shipped to.
    let modalCountries = props.category?.values;
    let selectedCount = props.category?.values?.length ?? 0;
    if (props.category?.all) {
        modalCountries = allCountries?.map(country => ({id: country.alpha2, name: country.name}));
        selectedCount = allCountries?.length ?? 0;
    }

    return (
        <>
            <Box
                className={cx(undefined, {
                    'from-view':props.fromView,
                })}
                onClick={(e) => {
                    // The category row around this is a ButtonBase that re-picks the category key.
                    e.stopPropagation();
                    setLogoOpen(true);
                }}
                sx={{
                    px:2,
                    height:32,
                    borderRadius:4,
                    display:"flex",
                    alignItems:'center',
                    cursor:"pointer",
                    background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],

                    '&.from-view' : {
                        height:24,
                    }
                }}
            >
                {selectedCount > 0 ?
                    <>
                        <Text noBreak bold>{selectedCount}</Text>
                        <Text noBreak light sx={{ml:0.5,}}>
                            {t("selected")}
                        </Text>
                    </>
                :
                    <Text noBreak>{t("no_selection")}</Text>
                }
            </Box>
            <MCountrySelector
                open={logoOpen}
                handleClose={() => {
                    setLogoOpen(false)
                }}
                countries={modalCountries}
                onSelect={(selected) => {
                    // Picking every country is stored as the flag, never as 200 ids: the filter decides
                    // what its "all" means, and countries resolve to the ones actually shipped to.
                    let categoryUpdate = {
                        all: false,
                        values: selected,
                    };

                    if (allCountries?.length > 0 && selected.length === allCountries.length) {
                        categoryUpdate = {
                            all: true,
                            allBehavior: resolvedFilter?.allBehavior ?? categoryAllBehaviors.ZEROFILL,
                            values: [],
                        };
                    }

                    props.setCurrentReport((prev) => ({
                        ...prev,
                        category:{
                            ...prev?.category,
                            ...categoryUpdate,
                        },
                    }));
                }}
            />
        </>
    )
}